import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { AddressSectionContent } from 'cpnl-common';
import { fetchAddressSection } from './AddressSectionSlice';
import { AddressSectionContentSelector } from './AddressSectionContentSelector';

export function useAddressSection(): AbstractContentState<AddressSectionContent> {
    return useCmsContent(fetchAddressSection, AddressSectionContentSelector);
}
